export default __webpack_public_path__ + "static/media/Boys_0.267da28c.svg";